export default __webpack_public_path__ + "static/media/2s.b9b16e41.svg";